import React from "react";
import "../../styles/global.scss";

const Select = (props) => {
  const {
    option,
    register,
    label,
    check,
    errors,
    placeholder,
    onChange,
    defaultValue,
    selected,
  } = props;

  return (
    <>
      <div className="select_Input">
        <select
          {...(register ? register(label, check) : {})}
          onChange={onChange}
          defaultValue={defaultValue}
          className={`${errors && errors[label] && "selectActive"}`}
        >
          <option value="" disabled selected hidden>
            {placeholder}
          </option>
          {option?.map((data, i) => {
            if (data?.id) {
              return (
                <>
                  <option value={data?.id}>{data?.option}</option>
                </>
              );
            }
            return (
              <>
                <option>{data}</option>
              </>
            );
          })}
        </select>
        {errors && errors[label] && (
          <span className="inputError">{errors[label]?.message}</span>
        )}
      </div>
    </>
  );
};

export default Select;
